import type { FormMetadata } from "@conform-to/react";

export function patchForm<T extends Record<string, unknown>>(
  form: FormMetadata<T>,
  patch: Partial<T>,
) {
  if (!form) return;
  Object.entries(patch).forEach(([name, value]) => {
    try {
      form.update({ name, value });
    } catch (error) {
      console.dir({ ...form });
      console.error("Failed to update form field", { name, value, error });
    }
  });
}
